<script lang="ts">
import {defineComponent} from "vue";
export default defineComponent({
  name: "CloseIcon",
})
</script>

<template>
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.75" d="M10.273 1.08059L1.08058 10.273M1.08058 0.727034L10.273 9.91942" stroke="black"
          stroke-width="1.5"/>
  </svg>
</template>

<style scoped lang="scss">
.white path {
  stroke: white;
}
</style>